import React from "react";
import "./app.css";
import { getImage } from "../../../../../../utils/getImages";
const CashVoucherCard = ({ cardData, activetab }) => {
    const getLangText = (item, key) => {
    if (!item) return "";
    switch (activetab) {
      case "simplified_chinese":
        return item[`simplified_chinese_${key}`] || "";
      case "treditonal_chinese":
        return item[`traditional_chinese_${key}`] || "";
      case "arabic":
        return item[`arabic_${key}`] || "";
      case "bahasa":
        return item[`bahasa_${key}`] || "";
      default:
        return item[key] || "";
    }
  };
  return (
    <div>
      <div className="col-md-12  py-5"  style={{ textAlign: "center" }}>
        <h1 className="title-color px-3 px-md-0 mt-10">
          {activetab === "english"
            ? cardData?.title
            : activetab === "simplified_chinese"
            ? cardData?.simplified_chinese_title
            : activetab === "arabic"
            ? cardData?.arabic_title
            : activetab === "bahasa"
            ? cardData?.bahasa_title
            : cardData?.traditional_chinese_title}
        </h1>
        <div
          style={{
            margin: "0 auto 40px",
            color: "#0b2b6b",
            fontFamily: "sans-serif",
            fontSize: "15px",
            lineHeight: "1.7",
            maxWidth: "800px",
          }}
          dangerouslySetInnerHTML={{
            __html: getLangText(cardData, "description"),
          }}
        />
      </div>
    </div>
  );
};

export default CashVoucherCard;
